import React from 'react'
import Sidebar from "../components/sidebar";
import Header from '../components/Header';
import ContactListMain from '../components/Contact/ContactListMain'

function ContactScreen() {
  return (
    <>
        <Sidebar />
        <main className="main-wrap">
            <Header />
            <ContactListMain />
        </main>
    </>
  )
}

export default ContactScreen